// @flow
import ItemTemplate, { type ProductData, type SlotData } from './item-template';


export default ItemTemplate;
export type { ProductData, SlotData };
